import $http from "../../axios";
import axios from "axios";
import { Notification } from "element-ui";
import { userIsCustomer, userIsSeller } from "../../util/roleFunctions";

export async function getServiceRequests({ state, commit }) {
  //Loader
  commit("setDefaulrSelectedServiceRequest");
  commit("setLoadingServiceRequests", true);

  // Sede
  const branchoffice_id = localStorage.selected_branchoffice;

  // Parametros
  let params = {
    params: state.tableServiceRequests.params
  };

  params.params.branchoffice_id = branchoffice_id;

  // Peticion
  await $http
    .get("/api/solicitudes-de-servicio", params)
    .then(response => {
      commit("setServiceRequests", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: "Error al traer las solicitudes de servicio.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      console.error(error);
    });

  commit("setLoadingServiceRequests", false);
}

export async function updateStateServiceRequest({ state, commit }, payload) {
  // Loader
  commit("setStateLoaderSelectedServiceRequest", true);
  commit("setErrorUpdateStatus", null);

  await $http
    .post("/api/solicitudes-de-servicio/actualizar-estado", {
      ...payload,
      emails: state.selectedMails
    })
    .then(async response => {
      let stateServiceRequest = response.data.data;
      await commit("setResponseSelectedServiceRequest", stateServiceRequest);

      // await commit("setHistoryStateServiceRequest");
      // await commit("finalizeSelectedServiceRequest");
    })
    .catch(error => {
      commit("setErrorUpdateStatus", error.response.data);
      commit("setStateLoaderSelectedServiceRequest", false);
      state.selectedServiceRequest.stateSelectedUpdate = null;
    });
}

export async function pdf(documentid) {}

export async function createDocumentByStateId({ commit, state }, params) {
  await $http
    .post("/api/solicitudes-de-servicio/crear-documento-estado-actual", {
      ...params,
      emails: state.selectedMails
    })
    .then(response => {
      commit("setPathsDocumentsStatus", response.data.documents);
      commit("setSelectedServiceRequest", response.data.serviceRequest);
      commit("setHistoryStateServiceRequest");
    })
    .catch(error => {
      if (error.response.status === 500) {
        commit("setCreateDocumentCurrentStateError", error.response.data);
      }

      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });

  commit("setStateLoaderSelectedServiceRequest", false);
  state.selectedServiceRequest.stateSelectedUpdate = null;
}

export async function fetchContacts(
  { commit, state },
  requestParameters = { params: state.paramsquery }
) {
  await $http
    .get("/api/terceros", requestParameters)
    .then(response => {
      commit("setContacts", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchContactsWarehouse({ commit, state }, data) {
  let user = JSON.parse(localStorage.user);
  // let selected_branchoffice = JSON.parse(localStorage.selected_branchoffice);
  // data.branchoffice_id = selected_branchoffice;

  const isSeller = userIsSeller();
  const isCustomer = userIsCustomer();

  if (isSeller) {
    data.seller_id = user.contact.id;
  }

  if (isCustomer) {
    data.contact_id = user.contact.id;
  }

  let params = {
    params: data
  };

  await $http
    .get("/api/establecimientos-vendedor/no-paginar", params)
    .then(response => {
      commit("setContactsWarehouse", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchTypes({ commit, state }) {
  await $http
    .get("/api/lista-tipos-solicitud")
    .then(response => {
      commit("setTypes", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchInvoicesContact({ commit, state }, id) {
  await $http
    .get(`/api/cartera/${id}`)
    .then(response => {
      commit("setInvoicesContact", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchCreditNoteDocuments({ commit, state }, id) {
  await $http
    .get(`/api/solicitudes-de-servicio/documentos-notacredito-tercero/${id}`)
    .then(response => {
      commit("setCreditNoteDocuments", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function updateStateHistoryById({ commit, state }, data) {
  await $http
    .post(
      `/api/solicitudes-de-servicio/actualizar-estado/${data.id}`,
      data.data
    )
    .then(response => {})
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchsellers({ commit, state }, text) {
  let params = { filter: text };
  await $http
    .get("/api/lista-vendedores", { params })
    .then(response => {
      commit("setSellers", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function searchProducts({ state, commit }, filter) {
  let params = state.paramsProduct;

  params.filter = filter;
  params.paginate = false;
  params.branchoffice_id = localStorage.selected_branchoffice;
  params.branchoffice_warehouse_id =
    localStorage.selected_branchoffice_warehouse;

  if (
    state.selectedServiceRequest.stateSelectedUpdate &&
    state.selectedServiceRequest.stateSelectedUpdate.id == 10
  ) {
    params.code_line_filter = "050";
    params.branchoffice_warehouse_code = "02";
  } else {
    params.code_line_filter = "";
    params.branchoffice_warehouse_code = "";
  }

  if ([1, 6].includes(state.params.service_requests_types_id)) {
    params.code_line_filter = "010";
  }

  await $http.get("/api/lista-productos", { params }).then(response => {
    commit("setProducts", response.data.data.data);
  });
}

export async function searchProductsLineBatteries({ state, commit }, filter) {
  let params = { ...state.paramsProduct };

  params.filter = filter;
  params.paginate = false;
  params.branchoffice_id = localStorage.selected_branchoffice;
  params.branchoffice_warehouse_id =
    localStorage.selected_branchoffice_warehouse;
  params.code_line_filter = "010";

  await $http.get("/api/lista-productos", { params }).then(response => {
    commit("setProductsLineBatteries", response.data.data.data);
    commit("setProducts", response.data.data.data);
  });
}

export async function searchProductsLineBatteriesScrap(
  { state, commit },
  filter
) {
  let params = { ...state.paramsProduct };

  params.filter = filter;
  params.paginate = false;
  params.branchoffice_id = localStorage.selected_branchoffice;
  params.branchoffice_warehouse_id =
    localStorage.selected_branchoffice_warehouse;
  params.code_line_filter = "050";

  await $http.get("/api/lista-productos", { params }).then(response => {
    commit("setProductsLineBatteriesScrap", response.data.data.data);
  });
}

export async function searchProductsLineBatteriesAndScrap(
  { state, commit },
  filter
) {
  let params = state.paramsProduct;

  params.filter = filter;
  params.paginate = false;
  params.branchoffice_id = localStorage.selected_branchoffice;
  params.branchoffice_warehouse_id =
    localStorage.selected_branchoffice_warehouse;
  params.code_line_filter = "010";

  await $http
    .get("/api/lista-productos", {
      params: { ...params, desc_subline_filter: "CHATARRA" }
    })
    .then(response => {
      commit("setProductsSublineScrap", response.data.data.data);
    });
}

// export async function searchProductsLineWarranties({ state, commit }, filter) {

//   let params = state.paramsProduct;

//   params.filter = filter;
//   params.paginate = false;
//   params.branchoffice_id = localStorage.selected_branchoffice;
//   params.branchoffice_warehouse_id =
//     localStorage.selected_branchoffice_warehouse;
//   params.code_line_filter = "010";

//   await $http.get("/api/lista-productos", { params }).then(response => {
//     commit("setProducts", response.data.data.data);
//   });

// }

export async function createRequest({ state, commit }) {
  await $http
    .post("/api/solicitudes-de-servicio/crear", {
      ...state.params,
      branchoffice_id: localStorage.selected_branchoffice,
      emails: state.selectedMails
    })
    .then(response => {
      commit("resetFormRequestService");
      commit("setResponseCreateRequest", response.data.data);
      Notification.success({
        title: "Exito!",
        message: "Registro Creado",
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
    })
    .catch(() => {
      Notification.error({
        title: "Error!",
        message: "Error al crear el registro.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function updateRequest({ state, commit }) {
  await $http
    .put(`/api/solicitudes-de-servicio/${state.params.id}`, {
      ...state.params
    })
    .then(() => {
      commit("resetFormRequestService");
      Notification.success({
        title: "Exito!",
        message: "Registro Actualizado",
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
    })
    .catch(() => {
      Notification.error({
        title: "Error!",
        message: "Error al crear el registro.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function uploadFilesRequest({ state, commit }, files) {
  let formData = new FormData();
  files.forEach(file => {
    formData.append("files[]", file);
  });

  await $http
    .post("/api/solicitudes-de-servicio/cargar-archivos", formData)
    .then(response => {
      commit("setResponseUploadFilesRequest", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: "Error al crear el registro.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function requestServiceReplacePhotographicEvidence(
  { state, commit },
  payload
) {
  await $http
    .put(
      "/api/actualizar-evidencia-fotografica/solicitudes-de-servicio",
      payload
    )
    .then(response => {
      commit("setReplacePhotographicEvidence", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: "Error al crear el registro.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchRequestById({ commit }, id) {
  await $http
    .get(`/api/solicitudes-de-servicio/${id}`)
    .then(response => {
      commit("setRequest", response.data);
    })
    .catch(error => {
      console.error(error);
      Notification.error({
        title: "Error!",
        message: "Error al traer la solicitud.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchVehicleDataByPlate({ commit }, plate) {
  await $http
    .get(`/api/solicitudes-de-servicio/verifik/detalles-vehiculo/${plate}`)
    .then(response => {
      commit("setVehicleDataByPlate", response.data.data);
    })
    .catch(error => {
      console.error(error);
      Notification.error({
        title: "Error!",
        message: "Error al traer la solicitud.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

/**
 * Este metodo trae los estados por tipo de solicitud
 *
 * @author Kevin Galindo
 */
export async function getStateByServiceRequestType(
  { commit },
  service_requests_type_id
) {
  let params = {
    params: {
      service_requests_type_id: service_requests_type_id
    }
  };

  await $http
    .get("/api/estados-por-solicitud-de-servicio", params)
    .then(response => {
      commit("setServiceRequestsStates", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: "Error al traer tipos de solicitudes de servicio.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchTypePhotographicEvidence({
  dispatch,
  state,
  rootState,
  commit
}) {
  if (!state.typePhotographicEvidence.length) {
    await dispatch(
      "parameters/listParameter",
      { params: { codeParamTable: "210", paginate: false } },
      { root: true }
    );
    commit(
      "setTypePhotographicEvidence",
      mapParameters(rootState.parameters.parameters)
    );
  }
}

export async function fetchTypesRotationRefreshmentProducts({
  dispatch,
  state,
  rootState,
  commit
}) {
  if (!state.typesRotationRefreshmentProducts.length) {
    await dispatch(
      "parameters/listParameter",
      { params: { codeParamTable: "220", paginate: false } },
      { root: true }
    );
    commit(
      "setTypesRotationRefreshmentProducts",
      mapParameters(rootState.parameters.parameters)
    );
  }
}

export async function fetchPurchaseOptions({
  dispatch,
  state,
  rootState,
  commit
}) {
  if (!state.purchaseOptions.length) {
    await dispatch(
      "parameters/listParameter",
      { params: { codeParamTable: "230", paginate: false } },
      { root: true }
    );
    commit(
      "setPurchaseOptions",
      mapParameters(rootState.parameters.parameters)
    );
  }
}

function mapParameters(parameters) {
  return parameters.map(p => {
    return { value: p.id, label: p.name_parameter, code: p.code_parameter };
  });
}

// Obtiene las ciudades
export async function fetchCities({ dispatch, state, rootState, commit }) {
  if (!state.cities.length) {
    await dispatch(
      "cities/fetchCities",
      { params: { department_id: null } },
      { root: true }
    );
    commit("setCities", rootState.cities.cities);
  }
}

export async function fetchListReasonsApprovals({
  dispatch,
  state,
  rootState,
  commit
}) {
  if (!state.listReasonsApprovals.length) {
    await dispatch(
      "parameters/listParameter",
      { params: { codeParamTable: "S-138", paginate: false } },
      { root: true }
    );
    commit(
      "setListReasonsApprovals",
      mapParameters(rootState.parameters.parameters)
    );
  }
}

export async function fetchListReasonsRejection({
  dispatch,
  state,
  rootState,
  commit
}) {
  if (!state.listReasonsRejection.length) {
    await dispatch(
      "parameters/listParameter",
      { params: { codeParamTable: "S-139", paginate: false } },
      { root: true }
    );
    commit(
      "setListReasonsRejection",
      mapParameters(rootState.parameters.parameters)
    );
  }
}

export async function createReverseApprovalDocument({ commit }, obj) {
  if (obj) {
    await $http
      .post("/api/solicitudes-de-servicio/reversar-documento", obj)
      .then(response => {
        commit("setPathsDocumentsStatus", response.data.documents);
        commit("setSelectedServiceRequest", response.data.serviceRequest);
        commit("setHistoryStateServiceRequest");
      })
      .catch(error => {
        commit("setErrorUpdateStatus", error.response.data);
      });
  }
}

export async function downloadDocument({ state }, data) {
  // const { url, name } = data;
  // axios({
  //   url, //your url
  //   method: "GET",
  //   responseType: "blob" // important
  // }).then(response => {
  //   const url = window.URL.createObjectURL(new Blob([response.data]));
  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.setAttribute("download", "file.pdf"); //or any other extension
  //   document.body.appendChild(link);
  //   link.click();
  // });
}

export async function searchDocumentNc({ commit, state }, params) {
  await $http
    .get("/api/documento/buscar/", {
      params
    })
    .then(response => {
      commit("setCreditNoteDocuments", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: "Error al buscar el documento",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function simpleUpdateServiceRequestById({ commit, state }, data) {
  await $http
    .post(
      `/api/solicitudes-de-servicio/actualizar-solicitud/${data.id}`,
      data.data
    )
    .then(response => {})
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}



// WEBPACK FOOTER //
// ./src/modules/request-service/actions.js